// TICKET-01338: the week view ("timeliste") renders the full ISO week of
// calendarDate, but calendar availability was only loaded for calendarDate's
// month. In a week spanning a month boundary (e.g. week 40 2026: Mon 28 Sep -
// Sun 4 Oct) the days outside the loaded month got no availability rows and
// rendered as fully closed/gray. Which days went gray depended on which month
// calendarDate happened to fall in, so the same week alternated between
// "Mon-Wed closed" and "Thu-Fri closed" across visits.
// The load window is therefore the whole month padded out to full
// Monday-Sunday weeks: that always contains the ISO week of any date in the
// month (week view) as well as the boundary days shown in the month grid.
export function getAvailabilityRange(calendarDate) {
    const date = new Date(calendarDate);
    const start = new Date(date.getFullYear(), date.getMonth(), 1);
    // Back up to Monday (getDay(): 0 = Sunday ... 6 = Saturday)
    start.setDate(start.getDate() - ((start.getDay() + 6) % 7));
    const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    // Extend forward to Sunday
    end.setDate(end.getDate() + ((7 - end.getDay()) % 7));
    return { start, end };
}

export default getAvailabilityRange;
